import { useState } from "react";
import SearchForm from "../HeaderSearch";
import { Link, Routes } from "react-router-dom";
import ROUTES from "../../router/constants";

function Header() {
  const [customerDropdown, setCustomerDropdown] = useState(false);
  const [vendorDropdown, setVendorDropdown] = useState(false);

  const handleDropdownCustomer = () => {
    setCustomerDropdown(!customerDropdown);
    setVendorDropdown(false);
  };

  const handleDropdownVendor = () => {
    setVendorDropdown(!vendorDropdown);
    setCustomerDropdown(false);
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Search Submitted");
  };

  return (
    <header className="bg-white shadow-md w-full  sticky top-0 z-50">
      <div className="container mx-auto px-10">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="text-2xl font-bold text-primary">Logo</div>

          {/* Search Form */}
          <div className="hidden md:flex flex-1 justify-center mx-4">
            <SearchForm onSearch={handleSearch} />
          </div>

          {/* Menu Items and Buttons */}
          <nav className="flex space-x-6 items-center">
            <Link
              to={ROUTES.Home}
              className="hover:text-primary text-[16px] font-bold"
            >
              Home
            </Link>
            <Link
              to={ROUTES.Listing}
              className="hover:text-primary text-[16px] font-bold"
            >
              Listing
            </Link>
            <Link
              to={ROUTES.Price}
              className="hover:text-primary text-[16px] font-bold"
            >
              Pricing
            </Link>
            <a href="#" className="hover:text-primary text-[16px] font-bold">
              About Us
            </a>
            <a href="#" className="hover:text-primary text-[16px] font-bold">
              Contact
            </a>

            {/* Customer Dropdown */}
            <div className="relative">
              <button
                onClick={handleDropdownCustomer}
                className="bg-white text-primary font-semibold px-8 py-2 border border-[#F8735F] hover:bg-primary hover:text-white transition rounded-lg"
              >
                Customer
              </button>
              {customerDropdown && (
                <div className="absolute right-0 mt-2 w-40 bg-white border shadow-lg rounded-md">
                  <Link
                    to={ROUTES.SignIn}
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Login
                  </Link>
                  <Link
                    to={ROUTES.SignUp}
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Register
                  </Link>
                </div>
              )}
            </div>

            {/* Vendor Dropdown */}
            <div className="relative">
              <button
                onClick={handleDropdownVendor}
                className="bg-primary text-white font-semibold px-8 py-2 rounded-lg hover:bg-white hover:text-primary hover:border-[#F8735F] border transition"
              >
                Vendor
              </button>
              {vendorDropdown && (
                <div className="absolute right-0 mt-2 w-40 bg-white border shadow-lg rounded-md">
                  <Link
                    to={ROUTES.SignIn}
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Login
                  </Link>
                  <Link
                    to={ROUTES.SignUp}
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Register
                  </Link>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
